import { Col, Empty, Form, Row, Tag } from "antd"


export const IngredientAvoidByClient = (props) => {
    // console.log(props);
    const { avoidIngredientsList } = props
    const [form] = Form.useForm();

    return (
        <>

            <Form
                name="notRecomandedListForm"
                className="notRecomandedListForm"
                form={form}
                layout="horizontal"
            // onFinish={onFinish}
            >
                {
                    avoidIngredientsList && avoidIngredientsList.length > 0 ? avoidIngredientsList.map((element) =>
                        <>
                            <Row className="not-recomend">
                                <Col xs={24} md={16} xl={11} xxl={24} >
                                    <h6 className="mb-0">In "{element?.tag?.name}" </h6>
                                </Col>
                                <Col xs={24} md={16} xl={11} xxl={24} className="not-recomend-list">
                                    {
                                        <Tag>{element?.ingredient?.name}</Tag>
                                    }
                                </Col>
                            </Row>
                        </>
                    )
                        :
                        <Empty />
                }
            </Form>

        </>
    )
}
